import React, { lazy } from 'react';
import PropTypes from 'prop-types';
import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';
import RenderComponent from './RenderComponent';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Form = lazy(() => import(`globalcomponents/UI/Form/${layout}`));

const FeedbackForm = ({ hasApiStatus, callback, sendFeedback }) => {
  const { i18n } = useTranslation();

  return (
    <>
      <Form
        type="server"
        direction="row"
        initialValues={{
          message: '',
        }}
        RenderComponent={RenderComponent}
        handleOnSubmit={(fields) => {
          sendFeedback({
            apiId: 'sendFeedback',
            data: {
              ...fields,
            },
            callback: callback,
          });
        }}
        handleOnCancel={(fields) => {}}
        customProps={{
          callback,
          hasApiStatus,
        }}
        validationSchema={Yup.object().shape({
          message: Yup.string().required(i18n.t('common.fieldRequiredMessage')),
        })}
      />
    </>
  );
};

FeedbackForm.propTypes = {
  apiStatus: PropTypes.object.isRequired,
  callback: PropTypes.func.isRequired,
};

export default FeedbackForm;
